import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from 'react';
import createRef from 'create-react-ref/lib/createRef';
import ChatMessages from './ChatMessages.react';

var ChatWindow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ChatWindow, _React$PureComponent);

  function ChatWindow() {
    _classCallCheck(this, ChatWindow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChatWindow).apply(this, arguments));
  }

  _createClass(ChatWindow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          msg = _this$props.msg,
          conversationData = _this$props.conversationData,
          submitQuestion = _this$props.submitQuestion,
          submitFeedback = _this$props.submitFeedback,
          typing = _this$props.typing,
          inputFieldEmpty = _this$props.inputFieldEmpty,
          enableTalkToAgent = _this$props.enableTalkToAgent,
          talkToAgent = _this$props.talkToAgent,
          inputValue = _this$props.inputValue,
          handleInputChange = _this$props.handleInputChange,
          handleEditLast = _this$props.handleEditLast,
          messagesEndRef = _this$props.messagesEndRef,
          HeaderIcon = _this$props.HeaderIcon,
          MessageIcon = _this$props.MessageIcon,
          AgentIcon = _this$props.AgentIcon,
          SubmitIcon = _this$props.SubmitIcon,
          TypingIcon = _this$props.TypingIcon,
          mobileAppMode = _this$props.mobileAppMode,
          chatModeBot = _this$props.chatModeBot;
      var input;
      return React.createElement("div", {
        className: "chatbot__container".concat(mobileAppMode ? ' chatbot__mobileAppMode' : '')
      }, !mobileAppMode && React.createElement("div", {
        className: "chatbot__header"
      }, React.createElement("span", null, React.createElement(HeaderIcon, {
        className: "chatbot__chatIcon"
      }), msg('chatBot.header')), enableTalkToAgent && chatModeBot && React.createElement("span", {
        className: "chatbot__talkToAgent",
        onClick: talkToAgent
      }, msg('chatBot.talkWithAgent'))), mobileAppMode && React.createElement("button", {
        type: "button",
        className: "chatbot__btn-talkToAgent",
        onClick: talkToAgent
      }, msg('chatBot.talkWithAgent')), React.createElement("div", {
        className: "chatbot__conversationContainer"
      }, React.createElement("div", {
        className: "chatbot__conversationBox"
      }, React.createElement(ChatMessages, {
        msg: msg,
        conversationData: conversationData,
        submitQuestion: submitQuestion,
        submitFeedback: submitFeedback,
        typing: typing,
        MessageIcon: MessageIcon,
        AgentIcon: AgentIcon,
        TypingIcon: TypingIcon,
        enableTalkToAgent: enableTalkToAgent
      })), React.createElement("div", {
        className: "chatbot__emptyDiv",
        ref: messagesEndRef
      })), React.createElement("form", {
        ref: createRef(),
        className: "chatbot__inputForm",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          submitQuestion({
            displayText: input.value
          });
          input.value = '';
        }
      }, React.createElement("input", {
        className: "chatbot__questionInput" // $FlowFixMe
        ,
        ref: function ref(node) {
          input = node;
        },
        onChange: handleInputChange,
        onKeyUp: handleEditLast,
        value: inputValue,
        placeholder: msg('chatBot.inputPlaceholder')
      }), React.createElement("button", {
        type: "submit",
        className: "chatbot__submitButton"
      }, React.createElement(SubmitIcon, {
        className: "chatbot__submitIcon ".concat(inputFieldEmpty ? '' : 'open')
      }))));
    }
  }]);

  return ChatWindow;
}(React.PureComponent);

export { ChatWindow as default };